<template>
    <div>
        <b-modal ref="my-modal-product-size" size="lg" centered hide-footer :title="'Tambah Ukuran'">
            <form v-on:submit.prevent="doSubmit">
              <b-row class="border ml-0 mr-0 mb-5 mt-3" v-for="(line, index) in addSize" v-bind:key="index">
                <b-col md="8">
                  <fg-input label="Ukuran">
                    <treeselect 
                      v-model="line.size" 
                      class="mb-3" 
                      placeholder="Pilih ukuran" 
                      :multiple="true"
                      :clear-on-select="true"
                      :options="sizeList"
                      @input="getData(line.size, index)"
                      name="size"
                      data-vv-as="size" ></treeselect>
                  </fg-input>
                </b-col>
                <b-col md="12">
                  <b-row v-for="(lineSize, lineIndex) in line.model" :key="lineIndex">
                    <b-col md="12">
                      <b-row>
                        <b-col md="4 pl-4">
                          <fg-input :required="true" for-input="capitalPrice" type="number" name="capitalPrice" id="capitalPrice" label="Harga Beli" placeholder="Enter Name" v-model="lineSize.capitalPrice" :error="errors.first('capitalPrice')" data-vv-as="harga beli"/>
                        </b-col>
                        <b-col md="4">
                          <fg-input :required="true" for-input="sellingPrice" type="number" name="sellingPrice" id="sellingPrice" label="Harga Jual" placeholder="Enter Name" v-model="lineSize.sellingPrice" :error="errors.first('sellingPrice')" data-vv-as="harga jual"/>
                        </b-col>
                        <b-col md="4">
                          <fg-input :required="true" for-input="memberPrice" type="number" name="memberPrice" id="memberPrice" label="Harga Member" placeholder="Enter Name" v-model="lineSize.memberPrice" :error="errors.first('memberPrice')" data-vv-as="harga member"/>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col md="4 pl-4">
                          <fg-input :required="true" for-input="smPrice" type="number" name="smPrice" id="smPrice" label="Harga spesial member" placeholder="Enter Name" v-model="lineSize.smPrice" :error="errors.first('smPrice')" data-vv-as="harga sepesial member"/>
                        </b-col>
                        <b-col md="4">
                          <fg-input :required="true" for-input="more3" type="number" name="more3" id="more3" label="Harga lebih dari 3" placeholder="Enter Name" v-model="lineSize.more3" :error="errors.first('more3')" data-vv-as="harga lebih dari 3"/>
                        </b-col>
                        <b-col md="4">
                          <fg-input :required="true" for-input="more12" type="number" name="more12" id="more12" label="Harga lebih dari 12" placeholder="Enter Name" v-model="lineSize.more12" :error="errors.first('more12')" data-vv-as="harga lebih dari 3"/>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col md="4 pl-4">
                          <fg-input :required="true" for-input="dropshipper" type="number" name="dropshipper" id="dropshipper" label="Harga dropshipper" placeholder="Enter Name" v-model="lineSize.dropshipper" :error="errors.first('dropshipper')" data-vv-as="harga dropshipper"/>
                        </b-col>
                        <b-col md="4">
                          <fg-input :required="true" for-input="gold_member" type="number" name="gold_member" id="gold_member" label="Harga gold member" placeholder="Enter Name" v-model="lineSize.gold_member" :error="errors.first('gold_member')" data-vv-as="harga gold member"/>
                        </b-col>
                        <b-col md="4">
                          <fg-input :required="true" for-input="stock" type="number" name="stock" id="stock" label="Stok" placeholder="Enter Name" :error="errors.first('stock')" v-model="lineSize.stock" data-vv-as="Stok"/>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>

              <b-button :variant="'warning'" class="float-left" @click="hideModal"><font-awesome-icon :icon="'times'"/> Canle</b-button>

              <save-data-button :disabled="saveButtonData.isLoading" :is-create="$route.params.id !== undefined" :state="saveButtonData.isLoading && saveButtonData.state === 1 ? 2 : saveButtonData.state" :is-loading="saveButtonData.isLoading"/>
              
            </form>
        </b-modal>
    </div>
</template>
<script>
import SaveData from '@/components/Buttons/SaveData'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
export default {
  components: {
    SaveDataButton: SaveData,
    Treeselect
  },
  data () {
    return {
      apiUrl: {
        size: window.AppConfig.apiUrl + 'size'
      },
      isLoading: false,
      addSize: [],
      sizeList: [],
      color: null,
      blockRemovalSize: true,
      saveButtonData: {
        isLoading: false,
        state: 1
      }
    }
  },
  mounted () {
    this.addLineSize()
    this.getSize()
  },
  watch: {
    addSize () {
      this.blockRemovalSize = this.addSize.length <= 1
    }
  },
  methods: {
    getSize () {
      this.$http.get(this.apiUrl.size + '?limit=100').then(response => {
        this.sizeList = []
        response.data.data.forEach(data => {
          this.sizeList.push({
            id: data.id,
            label: data.name
          })
        })
        this.sizeList
      })
    },
    showModal (color) {
      this.color = color
      this.$refs['my-modal-product-size'].show()
    },
    hideModal () {
      this.$refs['my-modal-product-size'].hide()
    },
    getData (value, indexRow) {
      if (value.length <= this.addSize[indexRow].model.length) {
        // removeItem()
        this.addSize[indexRow].model.pop()
      } else {
        this.addSize[indexRow].model.push({
          sizeId: value[value.length - 1],
          capitalPrice: 0,
          sellingPrice: 0,
          memberPrice: 0,
          dropshipper: 0,
          gold_member: 0,
          smPrice: 0,
          more3: 0,
          more12: 0,
          stock: 0
        })
      }
      // console.log(this.model.size)
    },
    addLineSize () {
      // let checkEmptyLines = this.lines.filter(line => line.color === null)
      // if (checkEmptyLines.length >= 1 && this.lines.length > 0) return
      this.addSize.push({
        color: null,
        size: [],
        model: []
      })
    },
    removeLine (lineId) {
      if (!this.blockRemovalSize) {
        this.addSize.splice(lineId, 1)
      }
    },
    doSubmit () {
      this.$swal({
        title: 'Are you sure?',
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'No',
        confirmButtonText: 'Yes',
        cancelButtonClass: 'btn btn-default',
        confirmButtonClass: 'btn btn-danger mr-3',
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          let productSizes = []
          this.addSize[0].model.forEach(data => {
            productSizes.push({
              product_color_id: this.color.id,
              size_id: data.sizeId,
              capital_price: data.capitalPrice,
              selling_price: data.sellingPrice,
              memberPrice: data.memberPrice,
              dropshipper: data.dropshipper,
              gold_member: data.gold_member,
              smPrice: data.smPrice,
              more3: data.more3,
              more12: data.more12,
              stock: data.stock
            })
          })
          this.$http.post(window.AppConfig.apiUrl + 'product-size', {
            productSizes: productSizes
          })
          .then(response => {
            this.hideModal()
            this.$emit('getDetail')
            this.$store.dispatch('notification/success', 'Ukuran berhasil ditambah.')
          })
          .catch(error => {
            this.$store.dispatch('notification/error', error)
          })
        }
      })
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/Dashboard/Pages/Products/ModalAddSize.vue